"use strict";

exports.__esModule = true;
exports.default = void 0;
var _createAssigner = _interopRequireDefault(require("./_createAssigner.js"));
var _allKeys = _interopRequireDefault(require("./allKeys.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Fill in a given object with default properties.
var _default = exports.default = (0, _createAssigner.default)(_allKeys.default, true);